import Clients from "../pages/Clients";
import Home from "../pages/Home";
import OurJourney from "../pages/OurJourney";
import Services from "../pages/Services";
import SolutionsSection from "../pages/SolutionsSection";
import WhyChooseUs from "../pages/WhyChooseUs";


export default function HeroSection() {
  return (
    <div>
      <Home/>
      <SolutionsSection/>     
      <Services/>
      <Clients/>
      <WhyChooseUs/>
      <OurJourney/>
    </div>
  );
}
